"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M16.48 2H7.52A5.526 5.526 0 002 7.52v8.96A5.525 5.525 0 007.52 22h8.96A5.526 5.526 0 0022 16.48V7.52A5.526 5.526 0 0016.48 2zm3.746 14.48a3.75 3.75 0 01-3.745 3.745H7.519a3.749 3.749 0 01-3.744-3.744V7.519a3.749 3.749 0 013.744-3.744h8.962a3.75 3.75 0 013.744 3.744v8.962z" }),
    React.createElement("path", { d: "M12 6.847A5.16 5.16 0 006.846 12 5.16 5.16 0 0012 17.154 5.16 5.16 0 0017.154 12 5.16 5.16 0 0012 6.847zm0 8.532A3.383 3.383 0 018.621 12 3.383 3.383 0 0112 8.621a3.383 3.383 0 013.379 3.38A3.383 3.383 0 0112 15.378zm5.37-10.037a1.306 1.306 0 00-1.302 1.301 1.309 1.309 0 001.302 1.302c.343 0 .678-.14.92-.381a1.307 1.307 0 00.001-1.841 1.307 1.307 0 00-.921-.38z" })), "Instagram");
//# sourceMappingURL=Instagram.js.map